// @dynamic-i18n-keys
// sidebar.*
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { getSeeAllBI } from '../../helpers';

import { sanitizeHref } from '@wix/da-url';

import s from './SeeAllLink.scss';

interface Props {
  contentType: string;
  deviation: PapiDeviation;
  type: 'seeall' | 'compare';
  url?: string;
  className?: string;
  onClick?: () => void;
}

const SeeAllLink: React.FC<Props> = ({ contentType, deviation, type, url, className, onClick }) => {
  const { t } = useTranslation();

  return (
    <TextButton
      className={classnames(s['root'], className)}
      variant="main"
      size="small"
      href={sanitizeHref(url)}
      onClick={onClick}
      biData={getSeeAllBI(contentType, deviation)}
    >
      {t([`sidebar.${type}.${contentType}`, `sidebar.${type}`])}
    </TextButton>
  );
};
SeeAllLink.displayName = 'SeeAllLink';

export default SeeAllLink;
